// en, de, fr, pt
export default {
  en: {
    appName: 'Self Improvee',
    layout: {
      focus: 'Focus & Do',
      plan: 'Dream & Plan',
      learn: 'Review & Learn'
    },
    dashboard: {
      title: 'Dashboard'
    },
    goals: {
      current: {
        title: 'Actions',
      },
      planner: {
        title: 'Goal Planner'
      }
    },
    dreams: {
      list: {
        title: 'Dream Board',
      },
    },
    stories: {
      list: {
        title: 'Journal'
      }
    },
    insights: {
      list: {
        title: 'Insights'
      }
    },
    tips: {
      list: {
        title: 'Knowledge'
      }
    },
    planner: {
      title: 'Action Board'
    },
    journey: {
      title: 'My Journey'
    },
    feedback: {
      title: 'Give us feedback'
    },
    donate: {
      title: 'Buy us coffee'
    },
    community: {
      title: 'Join community'
    }
  }
}
